import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18n';
import Dialog from 'Components/Base/Dialog';

const i18nOpts = { scope: 'notifications.mark_all_as_read_confirmation' };

const MarkAllAsReadDialog = ({ isOpen, onClose, onConfirm }) => (
  <Dialog
    className="notification-tray__dialog"
    isOpen={isOpen}
    title={t('description', i18nOpts)}
    onClose={onClose}
    footer={
      <div className="notification-tray__dialog-footer">
        <button
          className="buttonV2 button-subtle"
          onClick={onClose}
        >
          {t('cancel', i18nOpts)}
        </button>
        <button
          className="buttonV2"
          onClick={onConfirm}
        >
          {t('confirm', i18nOpts)}
        </button>
      </div>
    }
  />
);

MarkAllAsReadDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default MarkAllAsReadDialog;
